module.exports = __webpack_public_path__ + "img/zhengjiayanyijuyuan.4f0984c7.png";